import { configureStore } from '@reduxjs/toolkit';
import categoriesReducer from './slices/categoriesSlice';
import subcategoriesReducer from './slices/subcategoriesSlice';
// import subsubcategoriesReducer from './slices/subsubcategoriesSlice';
import productsReducer from './slices/productsSlice';
import cartReducer from './slices/cartSlice';
import authReducer from './slices/authSlice';
import usersReducer from './slices/usersSlice';
import ordersReducer from './slices/orderSlice';
import { storefrontCategoriesApi } from './slices/storefrontCategoriesSlice';
import { storefrontProductsApi } from './slices/storefrontProductsSlice';
import { sessionMiddleware } from './middleware/sessionMiddleware';

export const store = configureStore({
  reducer: {
    categories: categoriesReducer,
    subcategories: subcategoriesReducer,
    // subsubcategories: subsubcategoriesReducer,
    products: productsReducer,
    cart: cartReducer,
    auth: authReducer,
    users: usersReducer,
    orders: ordersReducer,
    [storefrontCategoriesApi.reducerPath]: storefrontCategoriesApi.reducer,
    [storefrontProductsApi.reducerPath]: storefrontProductsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(sessionMiddleware)
      .concat(storefrontCategoriesApi.middleware)
      .concat(storefrontProductsApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
